import { InAppMessageRequest } from "../evalautor/iam/InAppMessageRequest"
import Evaluator, { EvaluatorContext } from "../evalautor/Evaluator"
import { Experiment, InAppMessageContextMessage } from "../../model/model"
import ObjectUtil from "../../util/ObjectUtil"
import ExperimentEvaluation from "../evalautor/experiment/ExperimentEvaluation"
import ExperimentContextualEvaluator from "../evalautor/experiment/ExperimentContextualEvaluator"

export default class InAppMessageResolver {
  constructor(
    private readonly experimentEvaluator: InAppMessageExperimentEvaluator,
    private readonly messageSelector: InAppMessageSelector
  ) {}

  resolve(request: InAppMessageRequest, context: EvaluatorContext): InAppMessageContextMessage {
    const experiment = this.experiment(request)
    if (ObjectUtil.isNullOrUndefined(experiment)) {
      return this.messageSelector.select(
        request.inAppMessage,
        (message) => message.lang === request.inAppMessage.messageContext.defaultLang
      )
    }

    const evaluation = this.experimentEvaluator.evaluate(request, context, experiment)

    return this.messageSelector.select(
      request.inAppMessage,
      (message) =>
        message.lang === request.inAppMessage.messageContext.defaultLang &&
        evaluation.variationKey === message.variationKey
    )
  }

  private experiment(request: InAppMessageRequest): Experiment | null {
    const experimentContext = request.inAppMessage.messageContext.experimentContext

    if (experimentContext === null) return null

    return ObjectUtil.requiredNotNullOrUndefined(
      request.workspace.getExperimentOrNull(experimentContext.key),
      () => `Experiment[${experimentContext.key}]`
    )
  }
}

export class InAppMessageSelector {
  select(
    inAppMessage: InAppMessageRequest["inAppMessage"],
    condition: (message: InAppMessageContextMessage) => boolean
  ): InAppMessageContextMessage {
    const message = inAppMessage.messageContext.messages.find(condition)
    return ObjectUtil.requiredNotNullOrUndefined(message, () => `InAppMessage must be decided [${inAppMessage.id}]`)
  }
}

export class InAppMessageExperimentEvaluator extends ExperimentContextualEvaluator<InAppMessageRequest> {
  constructor(protected readonly evaluator: Evaluator) {
    super(evaluator)
  }

  decorate(
    request: InAppMessageRequest,
    context: EvaluatorContext,
    evaluation: ExperimentEvaluation
  ): ExperimentEvaluation {
    context.setProperty("experiment_id", evaluation.experiment.id)
    context.setProperty("experiment_key", evaluation.experiment.key)
    context.setProperty("variation_id", evaluation.variationId)
    context.setProperty("variation_key", evaluation.variationKey)
    context.setProperty("experiment_decision_reason", evaluation.reason)

    return evaluation
  }
}
